import React from "react";
import { Modal, ModalHeader, ModalBody, Button, Spinner } from "reactstrap";

const ConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  isLoading,
  title,
  message,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader className="border-bottom text-capitalize">
        {title}
      </ModalHeader>
      <ModalBody>
        <div className="d-flex align-items-center flex-column text-center">
          <h6 style={{ fontSize: "15px" }}>{message}</h6>
          <div className="d-flex my-4">
            <Button color="danger" className="me-3" onClick={toggle}>
              No
            </Button>
            <Button color="primary" onClick={onConfirm} disabled={isLoading}>
              Yes
              {isLoading && (
                <Spinner color="white" size="sm" className="ml-2" />
              )}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
